import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=c163144e&scoped=true&"
import script from "./EditInfo.vue?vue&type=script&lang=js&"
export * from "./EditInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=c163144e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c163144e",
  null
  
)

export default component.exports